<template>
  <div :id="mapId" v-show="showMap" style="width:100%; height:15rem;" />
</template>
<script>
import { GoogleMapHelper } from 'Features/bizgainOnboarding/helpers/googleMapHelper';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      googleMapObj: null,
      googleSessionToken: null,
      marker: null,
      googleMapHelper: null,
      placeDetails: null,
      circle: null,
      searchResults: null,
      selectedLocations: [],
      latitude: null,
      longitude: null,
      currentLocationDetails: null
    }
  },
  computed: {
    ...mapGetters(['portal'])
  },
  props: {
    searchLocation: {
      type: String,
      default: null
    },
    mapId: {
      type: String,
      required: true
    },
    showMap: {
      type: Boolean,
      default: false
    },
    regionSpecificLocations: {
      type: Array,
      default: null
    }
  },
  methods: {
    async mapsInit() {
      this.googleMapHelper = new GoogleMapHelper();
      let googleMapObj = await this.googleMapHelper.mapInitalize(document.getElementById(`${this.mapId}`));
      if (googleMapObj) {
        this.googleMapObj = googleMapObj;
        this.googleSessionToken = this.googleMapObj.sessionToken;
      }
      this.currentLocationDetails = await this.googleMapHelper.getGoogleCurrentLocationDetails();
      this.latitude = this.placeDetails && this.placeDetails.location && this.placeDetails.location.latitude ? this.placeDetails.location.latitude : this.currentLocationDetails.latitude;
      this.longitude = this.placeDetails && this.placeDetails.location && this.placeDetails.location.longitude ? this.placeDetails.location.longitude : this.currentLocationDetails.longitude;
    },
    displaySuggestions(predictions, status) {
      let searchResults = this.googleMapHelper.getGoogleMapSuggesstion(predictions, status);
      if (!this.regionSpecificLocations) {
        this.$emit('searchResult', searchResults);
        this.$emit('placeSuggestionsLoading', false);
      } else {
        let regionSpecificSearchResult = searchResults[0];
        let regionSpecificLocation = this.regionSpecificLocations.find(x => regionSpecificSearchResult.shortText.includes(x.shortText));
        if (regionSpecificLocation) {
          let promise = this.getPlaceDetails(regionSpecificSearchResult.value, false);
          promise.then(() => {
            let selectedLocation = {
              text: regionSpecificLocation.text,
              value: regionSpecificLocation.value,
              marker: this.marker,
              placeId: this.placeDetails.placeId
            };
            this.selectedLocations.push(selectedLocation);
          })
        }
      }
    },
    async getPlaceDetails(placeId, drawCircle = true, radius = 10) {
      if (placeId) {
        let placeDetails = await this.googleMapHelper.getGoogleMapPlaceDetails(placeId, this.googleSessionToken, this.googleMapObj.map, true);
        if (placeDetails) {
          this.placeDetails = placeDetails.googlePlaceDetails;
          this.googleSessionToken = placeDetails.sessionToken;
          this.marker = placeDetails.marker;
        }
        if (drawCircle) {
          this.drawCircle(radius);
        }
      }
    },
    setRegionSpecificLocation() {
      if (Array.isArray(this.regionSpecificLocations) && this.regionSpecificLocations.length > 0) {
        let newSelectedPlace = this.regionSpecificLocations.filter(x => !this.selectedLocations.find(y => y.text == x.text));
        if (newSelectedPlace.length > 0) {
          for (let i = 0; i < newSelectedPlace.length; i++) {
            this.getPlacePredictions(newSelectedPlace[i].text);
          }
        }
        let removeLocations = this.selectedLocations.filter(x => !this.regionSpecificLocations.find(y => y.text == x.text));
        if (removeLocations.length > 0) {
          removeLocations.forEach(location => {
            this.removeMarker(location.marker);
            let index = this.selectedLocations.indexOf(location);
            this.selectedLocations.splice(index, 1);
          });

          // When we remove a selected location from list,
          // We want the google map location marker to point to show a location from the selected list
          if (this.regionSpecificLocations.length > 0){
            this.getPlacePredictions(this.regionSpecificLocations[this.regionSpecificLocations.length - 1].text);
          }
        }
      }
    },
    drawCircle(radius = 10) {
      let primaryColorHexCode;
      if (this.portal && this.portal.theme) {
        let portalTheme = JSON.parse(this.portal.theme);
        if (portalTheme) {
          primaryColorHexCode = portalTheme.primary;
        }
      }
      let circleRadius = radius * 1000;
      this.googleMapHelper.deleteMapElement(this.circle);
      this.circle = this.googleMapHelper.drawCircle(
        this.googleMapObj.map,
        this.placeDetails.location.latitude,
        this.placeDetails.location.longitude,
        circleRadius,
        primaryColorHexCode
      );
    },
    removeMarker(marker) {
      this.googleMapHelper.deleteMapElement(marker);
    },
    getPlacePredictions(searchLocation) {
      this.$emit('placeSuggestionsLoading', true);
      this.googleMapObj.service.getPlacePredictions({
        input: searchLocation.trim(),
        sessionToken: this.googleSessionToken,
        location: new google.maps.LatLng(this.latitude, this.longitude),
        radius: 5000
      }, this.displaySuggestions);
    }
  },
  watch: {
    searchLocation: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && this.googleMapObj && this.googleMapObj.service && newValue != oldValue) {
          this.getPlacePredictions(this.searchLocation);
        }
      }
    },
    regionSpecificLocations() {
      this.setRegionSpecificLocation();
    },
    placeDetails(newvalue){
      this.latitude = newvalue && newvalue.location && newvalue.location.latitude ? newvalue.location.latitude : this.currentLocationDetails.latitude;
      this.longitude = newvalue && newvalue.location && newvalue.location.longitude ? newvalue.location.longitude : this.currentLocationDetails.longitude;
      this.$emit('updatePlaceDetails', newvalue);
    }
  }
}
</script>